var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNsbtLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#2E3035"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 15L15 0L0 15L15 30L30 15ZM11.1997 11.1435V22H9.5V15.3H6V14H9.5V8H11.171L18.6476 18.8954H18.8003V8H20.5V14H24V15.3H20.5V22H18.829L11.3524 11.1435H11.1997Z",
    fill: "#5428DB"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 32,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57023 12.6624C5.49973 12.6326 3.03448 13.2189 -0.134324 15.113C-0.4022 14.7788 0.686451 13.8427 0.500213 13.5002C0.501271 13.0018 2.49966 11.7706 2.50023 11.5002C7.50022 8.00022 13.0002 0.5 15.0002 -1.82203e-06C17.9904 2.57878 23.2714 8.15761 29.0002 12.0005C29.0084 12.1942 28.997 12.2079 29.0002 12.501C28.9992 13.0011 29.5016 13.3546 29.5002 14.0005C28.7521 13.1784 30.6771 14.6632 30.6725 14.7459C27.3072 16.4892 24.4756 17.0419 21.9224 16.884C19.0758 16.7078 16.6969 15.6457 14.5447 14.6848C14.4626 14.6482 14.3809 14.6117 14.2995 14.5754C12.0295 13.5635 9.98554 12.6971 7.57023 12.6624Z",
    fill: "#2E3035"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 15L15 0L0 15L15 30L30 15ZM11.1999 11.1435V22H9.50024V15.3H6.00024V14H9.50024V8H11.1713L18.6478 18.8954H18.8006V8H20.5002V14H24.0002V15.3H20.5002V22H18.8292L11.3527 11.1435H11.1999Z",
    fill: "#6A53F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNsbtLogo);
export default __webpack_public_path__ + "static/media/nsbt-logo.227ac705a6fcf240d7a239ed5bee326e.svg";
export { ForwardRef as ReactComponent };